import React from "react";

function Contact() {
  return (
    <div>
      <iframe
        title="JotForm"
        src="https://form.jotform.com/230851357484461"
        frameborder="0"
        style={{ width: "100%", height: "500px" }}
        allowfullscreen
      />
    </div>
  );
}

export default Contact;
